/**
 * Created by r4zi4l on 20.01.2022
 */

const FieldComponent = function (unit, options) { 
    UnitComponent.call(this, unit);

    if (options.fresh) {
        this.recipe = FieldComponent.RECIPES[cleverapps.meta.selectedLocationId()][0];
        this.time = 0;
        this.update();
    } else if (typeof options.recipe === "number") {
        this.recipe = FieldComponent.RECIPES[cleverapps.meta.selectedLocationId()][options.recipe];
        if (this.recipe) {
            this.time = options.time;
        }
        this.update();
    } else {
        this.updateExclamation();
    }
};

FieldComponent.prototype = Object.create(UnitComponent.prototype);
FieldComponent.prototype.constructor = FieldComponent;

FieldComponent.prototype.onInfoOpened = function () {
    if (Map2d.currentMap.advice && [FieldComponent.STATE_EMPTY, FieldComponent.STATE_READY].indexOf(this.getState()) !== -1) {
        Map2d.currentMap.advice.startInactiveHint({
            logic: Map2d.FIELD_HARVEST,
            once: false,
            delay: 1500
        });
    }
};

FieldComponent.prototype.onInfoClosed = function () {
    this.updateExclamation();
};

FieldComponent.prototype.onGrowthStart = function () {
    if (this.view) {
        this.view.handleGrowthStart();
    }
};

FieldComponent.prototype.onHarvested = function () {
    if (this.view) {
        this.view.handleHarvested();
    }
};

FieldComponent.prototype.onUpdateState = function () {
    if (this.view) {
        this.view.restoreState(true);
    }
};

FieldComponent.prototype.save = function (data) {
    if (this.recipe) {
        data.recipe = FieldComponent.RECIPES[cleverapps.meta.selectedLocationId()].indexOf(this.recipe);
        data.time = this.time;
    }
};

FieldComponent.prototype.destructor = function () {
    clearTimeout(this.timeout);
    clearTimeout(this.changeCropsTimeout);
    cleverapps.timeouts.clearTimeout(this.exclamationTimeout);
};

FieldComponent.prototype.getTimeLeft = function () {
    if (this.recipe && this.time) {
        return Math.max(0, this.time + this.recipe.duration - Date.now());
    }
    return 0;
};

FieldComponent.prototype.getState = function () {
    if (!this.recipe) {
        return FieldComponent.STATE_EMPTY;
    }

    if (this.time) {
        return this.getTimeLeft() > this.recipe.duration / 2 ? FieldComponent.STATE_EARLY_GROWING : FieldComponent.STATE_LATE_GROWING;
    }

    return FieldComponent.STATE_READY;
};

FieldComponent.prototype.getActionInfo = function () {
    const state = this.getState();

    if (state === FieldComponent.STATE_READY) {
        return {
            actions: [{
                type: FieldInfoView.ACTION_HARVEST,
                unit: this.unit
            }]
        };
    }

    if (state === FieldComponent.STATE_EARLY_GROWING || state === FieldComponent.STATE_LATE_GROWING) {
        const timeLeft = this.getTimeLeft();
        return {
            title: {
                code: this.recipe.prize.code,
                stage: this.recipe.prize.stage,
                icon: true
            },
            countdown: timeLeft,
            buttons: {
                speedup: {
                    unit: this.unit,
                    action: this.speedup.bind(this),
                    canCoins: false,
                    duration: timeLeft
                }
            }
        };
    }

    const actions = [];
    for (let i = 0; i < FieldComponent.RECIPES[cleverapps.meta.selectedLocationId()].length; ++i) {
        const recipe = FieldComponent.RECIPES[cleverapps.meta.selectedLocationId()][i];
        const action = {
            type: FieldInfoView.ACTION_PLANT,
            unit: this.unit,
            prize: recipe.prize
        };
        actions.push(action);

        if (recipe.fog && !Map2d.currentMap.fogs.isOpened(recipe.fog) || recipe.opened && !cleverapps.unitsLibrary.isOpened(recipe.prize)) {
            action.locked = true;
            break;
        }
    }

    if (actions.length) {
        return {
            actions
        };
    }
};

FieldComponent.prototype.canAcceptAction = function (action) {
    switch (action.type) {
        case FieldInfoView.ACTION_PLANT: return this.getState() === FieldComponent.STATE_EMPTY;
        case FieldInfoView.ACTION_HARVEST: return this.getState() === FieldComponent.STATE_READY;
    }
};

FieldComponent.prototype.acceptAction = function (action) {
    switch (action.type) {
        case FieldInfoView.ACTION_PLANT: this.plant(FieldComponent.findRecipe(action.prize)); break;
        case FieldInfoView.ACTION_HARVEST: this.harvest(); break;
    }
};

FieldComponent.prototype.plant = function (recipe) {
    this.recipe = recipe;
    this.time = Date.now();
    this.unit.save();

    this.update();

    InfoView.CloseInfo();
    this.onGrowthStart();

    this.updateExclamation();

    Map2d.mapEvent(Map2d.FIELD_PLANT, { unit: this.unit });
};

FieldComponent.prototype.update = function () {
    clearTimeout(this.timeout);
    clearTimeout(this.changeCropsTimeout);

    if (!this.recipe) {
        return;
    }

    const timeLeft = this.getTimeLeft();
    if (timeLeft === 0) {
        this.time = undefined;
        this.unit.save();
        this.onUpdateState();
    } else {
        this.timeout = new cleverapps.LongTimeout(this.update.bind(this), timeLeft);
    }

    if (timeLeft > this.recipe.duration / 2) {
        this.changeCropsTimeout = new cleverapps.LongTimeout((() => {
            this.onUpdateState();
        }), timeLeft - this.recipe.duration / 2);
    }
};

FieldComponent.prototype.speedup = function () {
    this.time = undefined;
    this.update();
};

FieldComponent.prototype.harvest = function () {
    const recipe = this.recipe;

    const units = [new Unit(recipe.prize)];
    const remains = Map2dLocation.currentLocation.spawn(units, this.unit, { radius: Map2d.RADIUS_BIG, spawnSource: "fieldcomponent" });
    if (remains.length) {
        return;
    }

    InfoView.CloseInfo(() => {
        cleverapps.timeouts.clearTimeout(this.exclamationTimeout);
        this.exclamationTimeout = cleverapps.timeouts.setTimeout(this.updateExclamation.bind(this), 2000);
    });

    this.recipe = undefined;
    this.onHarvested();
    this.unit.save();
    Map2d.mapEvent(Map2d.FIELD_HARVEST, { unit: this.unit });
};

FieldComponent.prototype.updateExclamation = function () {
    cleverapps.timeouts.clearTimeout(this.exclamationTimeout);

    if (this.getState() === FieldComponent.STATE_EMPTY && !InfoView.IsDisplayedFor(this.unit)) {
        this.unit.setPrizes({ sprite: bundles.merge.frames.prize_wheat });
    } else {
        this.unit.setPrizes(undefined);
    }
};

FieldComponent.STATE_EMPTY = 0;
FieldComponent.STATE_EARLY_GROWING = 1;
FieldComponent.STATE_LATE_GROWING = 2;
FieldComponent.STATE_READY = 3;

FieldComponent.findRecipe = function (unit) {
    for (let i = 0; i < FieldComponent.RECIPES[cleverapps.meta.selectedLocationId()].length; ++i) {
        const recipe = FieldComponent.RECIPES[cleverapps.meta.selectedLocationId()][i];
        if (Unit.Equals(unit, recipe.prize)) {
            return recipe;
        }
    }
};

FieldComponent.RECIPES = {};
